import React from 'react';
import PropTypes from 'prop-types';
import { Div, FormItem, FormText, InputNumber, Row, Col } from 'ui';
import { injectIntl, FormattedNumber } from 'react-intl';
// eslint-disable-next-line
import ReferenceDataDropdown from 'common/reference-data/containers/reference-data-dropdown-container';
import { orderStatus } from 'utils/app-configs';
import { miscellaniousCostRegex } from '../../../utils/app-configs';

const FixedOperations = ({
  taskList,
  orderId,
  fromScratch,
  disabled,
  onOperationFieldChange,
  onVisitTypeChange,
  intl,
  form,
  activeStatus,
}) => {
  const { getFieldDecorator } = form;
  const {
    id,
    laborTime,
    travelTime,
    travelDistance,
    expenses,
    allowance,
    environmental,
    chemAnalysis,
    refrigrant,
  } = taskList;

  const translateUnit = (uom) => {
    const translatableUoms = ['STD', 'KMT', 'MIL'];
    if (translatableUoms.includes(uom)) {
      return intl.formatMessage({ id: `equipment.taskList.uom.${uom}` });
    }
    return uom;
  };

  const canEditField = () => !(activeStatus && activeStatus.id >= orderStatus.executed);

  const renderOperationField = (name, operationField) => {
    if (operationField) {
      return (
        <span>
          {' '}
          {canEditField() ?
            <InputNumber
              min={0}
              disabled={!operationField.editable || disabled}
              value={operationField.value}
              onChange={value => !isNaN(value) && onOperationFieldChange(name, value)}
            />
            :
            <FormattedNumber value={operationField.value} />
          }{' '}
          {translateUnit(operationField.unit)}
        </span>
      );
    }
    return null;
  };

  const visitTypeValidator = getFieldDecorator('taskListVisitType', {
    initialValue: id,
  });

  const expensesValidator = getFieldDecorator('expenses', {
    rules: [{
      pattern: miscellaniousCostRegex,
      message: intl.formatMessage({ id: 'rules.MISCELLANEOUS_RULE_GENERAL' }),
    }],
  });

  return (
    <Div marginBottom={10}>
      <Row type='flex' gutter={16} marginRight={0}>
        <Col md={6} sm={24} xs={24} paddingRight={55}>
          <FormItem label={intl.formatMessage({ id: 'taskList.TYPES' })} colon={false}>
            {visitTypeValidator(
              <ReferenceDataDropdown
                onObjectChanged={selectedType => onVisitTypeChange(selectedType && selectedType.id)}
                disabled={disabled || !fromScratch || !canEditField}
                urlParams={{ orderId }}
                type='order'
                name='taskListTypes'
                valueLabel='name'
                valueKey='id'
              />,
            )}
          </FormItem>
        </Col>
        <Col md={3} sm={24} xs={24}>
          <FormItem label={intl.formatMessage({ id: 'taskList.LABOR_TIME' })} colon={false}>
            <FormText>{renderOperationField('laborTime', laborTime)}</FormText>
          </FormItem>
        </Col>
        <Col md={3} sm={24} xs={24}>
          <FormItem label={intl.formatMessage({ id: 'taskList.TRAVEL_TIME' })} colon={false}>
            <FormText>{renderOperationField('travelTime', travelTime)}</FormText>
          </FormItem>
        </Col>
        <Col md={3} sm={24} xs={24}>
          <FormItem label={intl.formatMessage({ id: 'taskList.TRAVEL_DISTANCE' })} colon={false}>
            <FormText>{renderOperationField('travelDistance', travelDistance)}</FormText>
          </FormItem>
        </Col>
        <Col md={3} sm={24} xs={24}>
          <FormItem label={intl.formatMessage({ id: 'taskList.EXPENSES' })} colon={false}>
            {expensesValidator(<FormText>{renderOperationField('expenses', expenses)}</FormText>)}
          </FormItem>
        </Col>
      </Row>
      <Row type='flex' gutter={16} marginRight={0}>
        <Col md={6} sm={24} xs={24} /> {/* to add blank column */}
        <Col md={3} sm={24} xs={24}>
          <FormItem label={intl.formatMessage({ id: 'taskList.ALLOWANCE' })} colon={false}>
            <FormText>{renderOperationField('allowance', allowance)}</FormText>
          </FormItem>
        </Col>
        <Col md={3} sm={24} xs={24}>
          <FormItem label={intl.formatMessage({ id: 'taskList.ENVIRONMENTAL' })} colon={false}>
            <FormText>{renderOperationField('environmental', environmental)}</FormText>
          </FormItem>
        </Col>
        <Col md={3} sm={24} xs={24}>
          <FormItem label={intl.formatMessage({ id: 'taskList.CHEM_ANALYSIS' })} colon={false}>
            <FormText>{renderOperationField('chemAnalysis', chemAnalysis)}</FormText>
          </FormItem>
        </Col>
        <Col md={3} sm={24} xs={24}>
          <FormItem label={intl.formatMessage({ id: 'taskList.REFRIGRANT' })} colon={false}>
            <FormText>{renderOperationField('refrigrant', refrigrant)}</FormText>
          </FormItem>
        </Col>
      </Row>
    </Div>
  );
};

FixedOperations.propTypes = {
  taskList: PropTypes.object,
  fromScratch: PropTypes.bool,
  disabled: PropTypes.bool,
  onOperationFieldChange: PropTypes.func,
  onVisitTypeChange: PropTypes.func,
  intl: PropTypes.object,
  form: PropTypes.object,
  orderId: PropTypes.string,
  activeStatus: PropTypes.object,
};

export default injectIntl(FixedOperations);
